import React, { useEffect, useState } from "react";
import "../policyHolderPortal/policyHolderPortal.css";
import layout from "../../assets/img/policy_holder/person-preparing-get-driver-license.svg";
import login_bg from "../../assets/img/policy_holder/login_bg.svg";
import PaymentIdCardModal from "./PaymentIdCardModal";

import CustomerLogin from "../header/customerLogin";

function PolicyHolderPortal() {
  const [responsiveStatus, setResponsiveStatus] = useState(false);
  const [modalShow, setModalShow] = useState(false);

  useEffect(() => {
    const mediaQueries = {
      isSmallMobile: window.matchMedia("(max-width: 400px)"),
      isMobile: window.matchMedia("(max-width: 768px)"),
      isTablet: window.matchMedia("(max-width: 900px)"),
    };

    const updateItemsPerPage = () => {
      if (mediaQueries.isSmallMobile.matches) {
        setResponsiveStatus(true);
      } else if (mediaQueries.isMobile.matches) {
        setResponsiveStatus(true);
      } else if (mediaQueries.isTablet.matches) {
        setResponsiveStatus(true);
      } else {
        setResponsiveStatus(false);
      }
    };

    // Initial run
    updateItemsPerPage();

    // Event listeners
    Object.values(mediaQueries).forEach((mq) =>
      mq.addEventListener("change", updateItemsPerPage)
    );

    // Cleanup
    return () => {
      Object.values(mediaQueries).forEach((mq) =>
        mq.removeEventListener("change", updateItemsPerPage)
      );
    };
  }, []);

  return (
    <>
      <div
        style={styles.container}
        className="d-flex flex-column justify-content-center align-items-end vh-100"
      >
        <div
          style={styles.loginCardContainer}
          className={responsiveStatus ? "loginPadding" : "loginPadding me-5"}
        >
          {/* <div className="card shadow p-4 rounded-4"> */}
          <div className="text-center">
            <h4 className="login-heading text-center fw-bold mb-3 pb-2">
              Login to Portal
            </h4>
          </div>

          <CustomerLogin display="page" />
        </div>
      </div>
      <PaymentIdCardModal
        isOpen={modalShow}
        onClose={() => setModalShow(false)}
      />
    </>
  );
}

const styles = {
  container: {
    backgroundImage: `url(${layout})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },
  loginCardContainer: {
    width: "100%",
    maxWidth: "465px",
    background: "white",
    borderRadius: "16px",
    backgroundImage: `url(${login_bg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },
};

export default PolicyHolderPortal;
